export default "__VITE_ASSET__BIFnRrNF__"